import { tv } from 'tailwind-variants';

export const checkboxRecipe = tv({
  slots: {
    checkboxRoot:
      'relative border rounded-[4px] h-4 w-4 transition duration-100 ease-out',
  },
  variants: {
    status: {
      default: {
        checkboxRoot:
          'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800 cursor-pointer',
      },
      active: {
        checkboxRoot: 'bg-brand-blue-11 border-brand-blue-11 cursor-pointer',
      },
      disabled: {
        checkboxRoot: 'bg-brand-gray-5 border-brand-gray-5 cursor-not-allowed',
      },
    },
  },
  defaultVariants: {
    status: 'default',
  },
});
